import { render, staticRenderFns } from "./barrageDialog.vue?vue&type=template&id=173212d8&scoped=true"
import script from "./barrageDialog.vue?vue&type=script&lang=js"
export * from "./barrageDialog.vue?vue&type=script&lang=js"
import style0 from "./barrageDialog.vue?vue&type=style&index=0&id=173212d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173212d8",
  null
  
)

export default component.exports